import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    loading: false,
    caseInfo: null
};

const route = "modules/driverPerformance/views/events/modals/caseInfo/redux/slice";

export const getCase = createAsyncThunk("driverPerformance/eventTab/getCase", async (payload, { rejectWithValue }) => {
    const { caseNumber } = payload
    try {
        const response = await clientQuery(
            `
                query searchDriverPerformanceCases ($conditions: [DriverPerformanceCaseSearchInput], $sort: [DriverPerformanceCaseSortInput], $limit: Int, $offset: Int) {
                    data: searchDriverPerformanceCases (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            caseNumber
                            driverId
                            coachId
                            driver {
                                id
                                name
                                tagIds
                            }
                            coach {
                                firstName
                                lastName
                            }
                            status {
                                entityId
                                label
                                nextStep
                                nextStatusId
                            }
                            statusId
                            completedDate
                            driverCaseEventsCount
                            createdOn
                            startEvaluationDate
                            completedDate
                        }
                        total
                    }
                }
            `,
            {
                conditions: [{
                    fields: ["caseNumber"],
                    terms: [caseNumber],
                    exact: true
                }],
                limit: 1
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        if (response?.data?.items) {
            return response.data.items[0];
        } else {
            return null
        }

    } catch (exc) {
        ExceptionManager(exc, route, "getCase");
        return rejectWithValue(exc);
    }
}
);

//Slice
const driverPerformanceEventsTabCaseInfoRedux = createSlice({
    name: "driverPerformance/caseInfo",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getCase
        builder.addCase(getCase.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getCase.fulfilled, (state, action) => {
            state.loading = false;
            state.caseInfo = action.payload
        });
        builder.addCase(getCase.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabCaseInfoRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
